<div>
  <app-shared-freshness-indicator-container
    (click)="onFreshnessClick()"
    [currentStore]="{name: 'unknown', storeId: params.data.storeId}"
    [dataType]="types[0]">
  </app-shared-freshness-indicator-container>
</div>

